const mod = crateImports["react/jsx-runtime"];
const { Fragment,jsx,jsxs } = mod;
export { Fragment,jsx,jsxs };
export default mod.default ?? mod;